import { formatClassName as _formatClassName } from '../../utils/formatClassName.js';

var getPageClassName = function getPageClassName(pageType, contentType, className) {
  return _formatClassName(['page-template', pageType, contentType, className]);
};

var getPageBodyClassName = function getPageBodyClassName(_ref) {
  var usePageWrapper = _ref.usePageWrapper,
      pageBodyClassName = _ref.pageBodyClassName,
      banner = _ref.banner,
      toolbar = _ref.toolbar,
      footerButtons = _ref.footerButtons,
      headerTabs = _ref.headerTabs,
      showHeader = _ref.showHeader;
  return _formatClassName(["page-body ".concat(!usePageWrapper ? 'row' : ''), pageBodyClassName, banner, toolbar, {
    'has-footer': footerButtons,
    'header-tabs': headerTabs,
    'no-header': !showHeader
  }]);
};

export { getPageBodyClassName, getPageClassName };